export class UpdateSensorStatusDto {

  constructor(public reason: string, public active: boolean, public publishing: boolean) {
  }
}
